import script from "./SpecialView.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialView.vue?vue&type=script&setup=true&lang=js"

import "./SpecialView.vue?vue&type=style&index=0&id=40ed8922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ed8922"]])

export default __exports__